$(document).ready(function() {

  $('.swatches__swatch--regular .swatches__form--input').prop('checked', false);
  
  $('body').on('click', '.addToCartBeforeStyleSelect', function(){
    $('.selectOptionError').removeClass('hide');
  });

  $('body').on('click', '.swatches__form--input', function(){
    $('.selectOptionError').addClass('hide');
    var oprionVal = $(this).val();
    if(oprionVal == "With Stitched Blouse"){
      $('.extraFields').html('<div class="extraFields_select"> <p class="swatches__option-name h5"><strong>Size:</strong> </p> <select required class="required extraFieldsSelect" id="select-size" name="properties[Blouse Size]"> <option value="">Select Size</option> <option value="XS">XS</option><option value="S">S</option><option value="M">M</option><option value="L">L</option><option value="XL">XL</option><option value="XXL">XXL</option> </select> </div><div class="selectSizeError hide"><span>Please Select Size</span></div>')
      $('.addToCartBeforeStyleSelect_Container').removeClass('hide');
      $('.addToCartButton_Container').addClass('hide');
      $('.addToCartBeforeStyleSelectMain').addClass('beforeSizeSelect');
      $('.addToCartBeforeStyleSelectMain').removeClass('addToCartBeforeStyleSelect');
      $('.extraFields_sizeChart').removeClass('hide');
      
    }else{
      $('.extraFields').html('');
      $('.addToCartBeforeStyleSelect_Container').addClass('hide');
      $('.addToCartButton_Container').removeClass('hide');
      $('.extraFields_sizeChart').addClass('hide');
    }
  });

  $('body').on('click', '.beforeSizeSelect', function(){
    $('.selectSizeError').removeClass('hide');
  });

  $('body').on('change', '.extraFieldsSelect', function(){
    var sizeSelectVal = $(this).val();
    $('.selectSizeError').addClass('hide');
    if(sizeSelectVal == ''){
      $('.addToCartBeforeStyleSelect_Container').removeClass('hide');
      $('.addToCartButton_Container').addClass('hide');
      $('.addToCartBeforeStyleSelectMain').addClass('beforeSizeSelect');
      $('.addToCartBeforeStyleSelectMain').removeClass('addToCartBeforeStyleSelect');
    }else{
      $('.addToCartBeforeStyleSelect_Container').addClass('hide');
      $('.addToCartButton_Container').removeClass('hide');
    }
  });
  
});